import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 物业
 */
const rentalArea = {

  /**
   * 新增场地模板
   */
  addRentalAreaTemplate (companyId, name) {
    return axios.post(base.rentalArea.addRentalAreaTemplate, utils.postParamsArrayToJsonString({ companyId, name }))
  },
  /**
   * 删除场地模板
   */
  deleteRentalAreaTemplate (id) {
    return axios.post(base.rentalArea.deleteRentalAreaTemplate, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 修改场地模板
   */
  modifyRentalAreaTemplate (id, name) {
    return axios.post(base.rentalArea.modifyRentalAreaTemplate, utils.postParamsArrayToJsonString({ id, name }))
  },
  /**
   * 查询场地模板
   */
  listRentalAreaTemplates (companyId) {
    // return utils.simulateReslut([{ id: '1', name: '测试' }])
    return axios.post(base.rentalArea.listRentalAreaTemplates, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 新增场地模板设备
   */
  addRentalAreaTemplateEquipment (id, name, measureTemplateId, eventDetectRegulationTemplateId) {
    return axios.post(base.rentalArea.addRentalAreaTemplateEquipment, utils.postParamsArrayToJsonString({ id, name, measureTemplateId, eventDetectRegulationTemplateId }))
  },
  /**
   * 删除场地模板设备
   */
  deleteRentalAreaTemplateEquipment (id) {
    return axios.post(base.rentalArea.deleteRentalAreaTemplateEquipment, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询场地模板设备
   */
  listRentalAreaTemplateEquipment (id) {
    // return utils.simulateReslut([{ id: '1', name: '测试数据', measureTemplateId: '39', measureTemplateName: '电气回路模板', measureTemplateDisplayName: '电气回路模板', eventDetectRegulationTemplateId: '10328852984742318', eventDetectRegulationTemplateName: '低压__电气回路告警模板' }])
    return axios.post(base.rentalArea.listRentalAreaTemplateEquipment, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 修改场地模板设备
   */
  modifyRentalAreaTemplateEquipment (id, name, measureTemplateId, eventDetectRegulationTemplateId) {
    return axios.post(base.rentalArea.modifyRentalAreaTemplateEquipment, utils.postParamsArrayToJsonString({ id, name, measureTemplateId, eventDetectRegulationTemplateId }))
  },


  /**
   * 查询场地
   */
  getRentalArea (companyId) {
    return axios.post(base.rentalArea.getRentalArea, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 查询子场地
   * @param {*} areasId 
   * @param {*} containItself 
   * @returns 
   */
  getSubRentalAreas (areasId, containItself) {
    return axios.post(base.rentalArea.getSubRentalAreas, utils.postParamsArrayToJsonString({ areasId, containItself }))
  },
  /**
   * 新增场地
   */
  addRentalArea (companyId, name, place, area, orderNum, parentId) {
    return axios.post(base.rentalArea.addRentalArea, utils.postParamsArrayToJsonString({ companyId, name, place, area, orderNum, parentId }))
  },
  /**
   * 新增场地
   */
  addRentalAreaByTemplate (name, templateId, parentId, equipmentMountedOn, orderNum) {
    return axios.post(base.rentalArea.addRentalAreaByTemplate, utils.postParamsArrayToJsonString({ name, templateId, parentId, equipmentMountedOn, orderNum }))
  },

  /**
   * 修改场地
   */
  modifyRentalArea (areaId, name, place, area, orderNum, parentId) {
    return axios.post(base.rentalArea.modifyRentalArea, utils.postParamsArrayToJsonString({ areaId, name, place, area, orderNum, parentId }))
  },
  /**
   * 删除场地
   */
  deleteRentalArea (areaId) {
    return axios.post(base.rentalArea.deleteRentalArea, utils.postParamsArrayToJsonString({ areaId }))
  },

  /**
    * 查询场地开关
    */
  getRentalAreaSwitches (areaId) {
    return axios.post(base.rentalArea.getRentalAreaSwitches, utils.postParamsArrayToJsonString({ areaId }))
  },
  /**
  * 添加场地开关
  */
  addRentalAreaSwitch (areaId, measureId, name, remark, templateId, salespersonId, mountedOn) {
    return axios.post(base.rentalArea.addRentalAreaSwitch, utils.postParamsArrayToJsonString({ areaId, measureId, name, remark, templateId, salespersonId, mountedOn }))
  },
  // /**
  // * 修改场地开关
  // */
  // modifyRentalAreaSwitch (id, name) {
  //   return axios.post(base.rentalArea.modifyRentalAreaSwitch, utils.postParamsArrayToJsonString({ id, name }))
  // },
  /**
  * 删除场地开关
  */
  deleteRentalAreaSwitch (measureId) {
    return axios.post(base.rentalArea.deleteRentalAreaSwitch, utils.postParamsArrayToJsonString({ measureId }))
  },
  // /**
  // * 查询场地开关绑定测量点
  // */
  // getRentalAreaSwitchMeasureBindings (switchId) {
  //   return axios.post(base.rentalArea.getRentalAreaSwitchMeasureBindings, utils.postParamsArrayToJsonString({ switchId }))
  // },
  /**
  // * 添加场地开关绑定测量点
  // */
  // addRentalAreaSwitchBindingMeasure (switchId, startTime, endTime, measureId) {
  //   return axios.post(base.rentalArea.addRentalAreaSwitchBindingMeasure, utils.postParamsArrayToJsonString({ switchId, startTime, endTime, measureId }))
  // },
  // /**
  // * 修改场地开关绑定测量点
  // */
  // modifyRentalAreaSwitchBindingMeasure (id, startTime, endTime, measureId) {
  //   return axios.post(base.rentalArea.modifyRentalAreaSwitchBindingMeasure, utils.postParamsArrayToJsonString({ id, startTime, endTime, measureId }))
  // },
  // /**
  // * 删除场地开关绑定测量点
  // */
  // deleteRentalAreaSwitchBindingMeasure (id) {
  //   return axios.post(base.rentalArea.deleteRentalAreaSwitchBindingMeasure, utils.postParamsArrayToJsonString({ id }))
  // },
  /**
   * 查询场地常规用能计量
   */
  getRentalAreaEnergyMeasuringBasic1 (areaId, energyType) {
    return axios.post(base.rentalArea.getRentalAreaEnergyMeasuringBasic1, utils.postParamsArrayToJsonString({ areaId, energyType }))
  },
  /**
   * 查询场地用能计量
   */
  getRentalAreaEnergyMeasuringBasic2 (ids) {
    return axios.post(base.rentalArea.getRentalAreaEnergyMeasuringBasic2, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 新增场地用能计量
   */
  addRentalAreaEnergyMeasuringBasic (rentalAreaId, startTime, endTime, measureId, pointCode, pointNumber, energyType) {
    return axios.post(base.rentalArea.addRentalAreaEnergyMeasuringBasic, utils.postParamsArrayToJsonString({ rentalAreaId, startTime, endTime, measureId, pointCode, pointNumber, energyType }))
  },
  /**
   * 修改场地用能计量
   */
  modifyRentalAreaEnergyMeasuringBasic (id, startTime, endTime) {
    return axios.post(base.rentalArea.modifyRentalAreaEnergyMeasuringBasic, utils.postParamsArrayToJsonString({ id, startTime, endTime }))
  },
  /**
   * 删除场地用能计量
   */
  deleteRentalAreaEnergyMeasuringBasic (id) {
    return axios.post(base.rentalArea.deleteRentalAreaEnergyMeasuringBasic, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询场地公共用能分摊
   */
  getRentalAreaPublicEnergyDistributionMeasuring1 (areaId) {
    return axios.post(base.rentalArea.getRentalAreaPublicEnergyDistributionMeasuring1, utils.postParamsArrayToJsonString({ areaId }))
  },
  /**
   * 查询场地公共用能分摊
   */
  getRentalAreaPublicEnergyDistributionMeasuring2 (ids) {
    return axios.post(base.rentalArea.getRentalAreaPublicEnergyDistributionMeasuring2, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 新增场地公共用能分摊
   */
  addRentalAreaPublicEnergyDistributionMeasuring (rentalAreaId, energyType, name, startTime, endTime, measureId, pointCode, pointNumber, expression) {
    return axios.post(base.rentalArea.addRentalAreaPublicEnergyDistributionMeasuring, utils.postParamsArrayToJsonString({ rentalAreaId, energyType, name, startTime, endTime, measureId, pointCode, pointNumber, expression }))
  },
  /**
   * 修改场地公共用能分摊
   */
  modifyRentalAreaPublicEnergyDistributionMeasuring (id, name, startTime, endTime, expression) {
    return axios.post(base.rentalArea.modifyRentalAreaPublicEnergyDistributionMeasuring, utils.postParamsArrayToJsonString({ id, name, startTime, endTime, expression }))
  },
  /**
   * 删除场地公共用能分摊
   */
  deleteRentalAreaPublicEnergyDistributionMeasuring (id) {
    return axios.post(base.rentalArea.deleteRentalAreaPublicEnergyDistributionMeasuring, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 场地用量查询
   */
  getRentalAreaEnergyCostHour (areas, energyType, startTime, endTime) {
    return axios.post(base.rentalArea.getRentalAreaEnergyCostHour, utils.postParamsArrayToJsonString({ areas, energyType, startTime, endTime }))
  },
  /**
   * 场地用量查询
   */
  getRentalAreaEnergyCostDay (areas, energyType, startTime, endTime) {
    return axios.post(base.rentalArea.getRentalAreaEnergyCostDay, utils.postParamsArrayToJsonString({ areas, energyType, startTime, endTime }))
  },
  /**
   * 场地用量查询
   */
  getRentalAreaEnergyCostMonth (areas, energyType, startTime, endTime) {
    return axios.post(base.rentalArea.getRentalAreaEnergyCostMonth, utils.postParamsArrayToJsonString({ areas, energyType, startTime, endTime }))
  },
  /**
   * 场地用量查询
   */
  getRentalAreaEnergyCostYear (areas, energyType, startTime, endTime) {
    return axios.post(base.rentalArea.getRentalAreaEnergyCostYear, utils.postParamsArrayToJsonString({ areas, energyType, startTime, endTime }))
  },
  /**
   * 新增物业托管合同
   */
  addRentalAreaTrusteeshipContract (startTime, endTime, proprietorCompanyId, proprietorTransactorId, propertyCompanyId, propertyTransactorId, trusteeshipAreas, energyPricingConfig, basicCharges, takePercentageFromProfit) {
    return axios.post(base.rentalArea.addRentalAreaTrusteeshipContract, utils.postParamsArrayToJsonString({ startTime, endTime, proprietorCompanyId, proprietorTransactorId, propertyCompanyId, propertyTransactorId, trusteeshipAreas, energyPricingConfig, basicCharges, takePercentageFromProfit }))
  },
  /**
   * 终止合同
   */
  terminateRentalAreaTrusteeshipContract (id) {
    return axios.post(base.rentalArea.terminateRentalAreaTrusteeshipContract, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 业主查询场地托管合同
   */
  getRentalAreaTrusteeshipContractForProprietor (propertyCompanyId, propertyCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status) {
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipContractForProprietor, utils.postParamsArrayToJsonString({ propertyCompanyId, propertyCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status }))
  },
  /**
   * 物业查询场地托管合同
   */
  getRentalAreaTrusteeshipContractForProperty (propertyCompaniesId, proprietorCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status) {
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipContractForProperty, utils.postParamsArrayToJsonString({ propertyCompaniesId, proprietorCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status }))
  },
  /**
   * 新增租凭合同
   */
  addLeaseContract (startTime, endTime, lesseeNature, lesseeId, lesseeTransactorId, propertyCompanyId, propertyTransactorId, rentAreas, energyPricingConfig, basicCharges) {
    return axios.post(base.rentalArea.addLeaseContract, utils.postParamsArrayToJsonString({ startTime, endTime, lesseeNature, lesseeId, lesseeTransactorId, propertyCompanyId, propertyTransactorId, rentAreas, energyPricingConfig, basicCharges }))
  },
  /**
   * 终止合同
   */
  terminateLeaseContract (id) {
    return axios.post(base.rentalArea.terminateLeaseContract, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 物业查询租凭合同
   */
  getLeaseContractForProperty (propertyCompanyId, lesseeNature, lesseesId, signingTimeLeft, signingTimeRight, startTime, endTime, status) {
    return axios.post(base.rentalArea.getLeaseContractForProperty, utils.postParamsArrayToJsonString({ propertyCompanyId, lesseeNature, lesseesId, signingTimeLeft, signingTimeRight, startTime, endTime, status }))
  },
  /**
   * 个人租户查询租凭合同
   */
  getLeaseContractForPersonalLessee (propertyCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status) {
    return axios.post(base.rentalArea.getLeaseContractForPersonalLessee, utils.postParamsArrayToJsonString({ propertyCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status }))
  },
  /**
   * 公司租户查询租凭合同
   */
  getLeaseContractForCompanyLessee (companyId, propertyCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status) {
    return axios.post(base.rentalArea.getLeaseContractForCompanyLessee, utils.postParamsArrayToJsonString({ companyId, propertyCompaniesId, signingTimeLeft, signingTimeRight, startTime, endTime, status }))
  },
  /**
   * 业主查询场地托管收入账单
   */
  getRentalAreaTrusteeshipIncomeBillForProprietor (companyId, startTimeLeft, startTimeRight, propertyCompaniesId, status) {
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipIncomeBillForProprietor, utils.postParamsArrayToJsonString({ companyId, startTimeLeft, startTimeRight, propertyCompaniesId, status }))
  },
  /**
   * 物业查询场地托管收入账单
   */
  getRentalAreaTrusteeshipImcomeBillForProperty (companyId, startTimeLeft, startTimeRight, proprietorCompaniesId, status) {
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipImcomeBillForProperty, utils.postParamsArrayToJsonString({ companyId, startTimeLeft, startTimeRight, proprietorCompaniesId, status }))
  },
  /**
   * 物业查询租凭收入账单
   */
  getLeaseIncomeBillForProperty (companyId, startTimeLeft, startTimeRight, lesseeNature, lesseesId, status) {
    return axios.post(base.rentalArea.getLeaseIncomeBillForProperty, utils.postParamsArrayToJsonString({ companyId, startTimeLeft, startTimeRight, lesseeNature, lesseesId, status }))
  },
  /**
   * 个人租户查询租凭支出账单
   */
  getLeaseExpenditureBillForPersonalLessee (startTimeLeft, startTimeRight, propertyCompaniesId, status) {
    return axios.post(base.rentalArea.getLeaseExpenditureBillForPersonalLessee, utils.postParamsArrayToJsonString({ startTimeLeft, startTimeRight, propertyCompaniesId, status }))
  },
  /**
   * 业主设置账单自动支付设置
   */
  setRentalAreaTrusteeshipBillAutoPaymentForProprietor (companyId, contractId) {
    return axios.post(base.rentalArea.setRentalAreaTrusteeshipBillAutoPaymentForProprietor, utils.postParamsArrayToJsonString({ companyId, contractId }))
  },
  /**
   * 业主查询所有自动支付合同
   */
  listRentalAreaTrusteeshipContractOfBillAutoPaymentForProprietor (companyId) {
    return axios.post(base.rentalArea.listRentalAreaTrusteeshipContractOfBillAutoPaymentForProprietor, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 业主查询合同是否自动支付
   */
  getRentalAreaTrusteeshipContractBillAutoPaymentConfigForProprietor (companyId, contractsId) {
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipContractBillAutoPaymentConfigForProprietor, utils.postParamsArrayToJsonString({ companyId, contractsId }))
  },
  /**
   * 个人租户设置账单自动支付设置
   */
  setLeaseBillAutoPaymentForPersonalLessee (contractId) {
    return axios.post(base.rentalArea.setLeaseBillAutoPaymentForPersonalLessee, utils.postParamsArrayToJsonString({ contractId }))
  },
  /**
   * 个人租户查询所有自动支付合同
   */
  listLeaseContractOfBillAutoPaymentForPersonalLessee () {
    return axios.post(base.rentalArea.listLeaseContractOfBillAutoPaymentForPersonalLessee, utils.postParamsArrayToJsonString({}))
  },
  /**
   * 个人租户查询合同是否自动支付
   */
  getLeaseContractBillAutoPaymentConfigForPersonalLessee (contractsId) {
    return axios.post(base.rentalArea.getLeaseContractBillAutoPaymentConfigForPersonalLessee, utils.postParamsArrayToJsonString({ contractsId }))
  },
  /**
   * 手动生成物业托管订单
   */
  generateRentalAreaTrusteeshipBillManually (contractId, forDate) {
    return axios.post(base.rentalArea.generateRentalAreaTrusteeshipBillManually, utils.postParamsArrayToJsonString({ contractId, forDate }))
  },
  /**
   * 手动生成租凭订单
   */
  generateLeaseBillManually (contractId, forDate) {
    return axios.post(base.rentalArea.generateLeaseBillManually, utils.postParamsArrayToJsonString({ contractId, forDate }))
  },
  /**
   * 业主支付场地托管账单
   */
  paymentForProprietorRentalAreaTrusteeshipBill (companyId, billId, paymentMode) {
    return axios.post(base.rentalArea.paymentForProprietorRentalAreaTrusteeshipBill, utils.postParamsArrayToJsonString({ companyId, billId, paymentMode }))
  },
  /**
   * 物业支付场地托管账单
   */
  paymentForPropertyRentalAreaTrusteeshipBill (companyId, billId, paymentMode) {
    return axios.post(base.rentalArea.paymentForPropertyRentalAreaTrusteeshipBill, utils.postParamsArrayToJsonString({ companyId, billId, paymentMode }))
  },
  /**
   * 支付租凭账单
   */
  paymentForLeaseBill (billId, paymentMode) {
    return axios.post(base.rentalArea.paymentForLeaseBill, utils.postParamsArrayToJsonString({ billId, paymentMode }))
  },


  /**
  * 业主查询场地托管支出账单
  */
  getRentalAreaTrusteeshipExpenditureBillForProprietor (companyId, startTimeLeft, startTimeRight, propertyCompaniesId, status) {
    propertyCompaniesId = utils.arrayToJsonString(propertyCompaniesId)
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipExpenditureBillForProprietor, utils.postParamsArrayToJsonString({ companyId, startTimeLeft, startTimeRight, propertyCompaniesId, status }))
  },
  /**
  * 物业查询场地托管支出账单
  */
  getRentalAreaTrusteeshipExpenditureBillForProperty (companyId, startTimeLeft, startTimeRight, proprietorCompaniesId, status) {
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipExpenditureBillForProperty, utils.postParamsArrayToJsonString({ companyId, startTimeLeft, startTimeRight, proprietorCompaniesId, status }))
  },
  /**
  * 公司租户查询租凭支出账单
  */
  getLeaseExpenditureBillForCompanyLessee (startTimeLeft, startTimeRight, propertyCompaniesId, status) {
    propertyCompaniesId = utils.arrayToJsonString(propertyCompaniesId)
    return axios.post(base.rentalArea.getLeaseExpenditureBillForCompanyLessee, utils.postParamsArrayToJsonString({ startTimeLeft, startTimeRight, propertyCompaniesId, status }))
  },
  /**
  * 业主取消设置账单自动支付设置
  */
  unsetRentalAreaTrusteeshipBillAutoPaymentForProprietor (companyId, contractId) {
    return axios.post(base.rentalArea.unsetRentalAreaTrusteeshipBillAutoPaymentForProprietor, utils.postParamsArrayToJsonString({ companyId, contractId }))
  },
  /**
  * 物业设置账单自动支付设置
  */
  setRentalAreaTrusteeshipBillAutoPaymentForProperty (companyId, contractId) {
    return axios.post(base.rentalArea.setRentalAreaTrusteeshipBillAutoPaymentForProperty, utils.postParamsArrayToJsonString({ companyId, contractId }))
  },
  /**
  * 物业取消设置账单自动支付设置
  */
  unsetRentalAreaTrusteeshipBillAutoPaymentForProperty (companyId, contractId) {
    return axios.post(base.rentalArea.unsetRentalAreaTrusteeshipBillAutoPaymentForProperty, utils.postParamsArrayToJsonString({ companyId, contractId }))
  },
  /**
  * 物业查询所有自动支付合同
  */
  listRentalAreaTrusteeshipContractOfBillAutoPaymentForProperty (companyId) {
    return axios.post(base.rentalArea.listRentalAreaTrusteeshipContractOfBillAutoPaymentForProperty, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
  * 物业查询合同是否自动支付
  */
  getRentalAreaTrusteeshipContractBillAutoPaymentConfigForProperty (companyId, contractsId) {
    contractsId = utils.arrayToJsonString(contractsId)
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipContractBillAutoPaymentConfigForProperty, utils.postParamsArrayToJsonString({ companyId, contractsId }))
  },
  /**
  * 公司租户设置账单自动支付设置
  */
  setLeaseBillAutoPaymentForCompanyLessee (companyId, contractId) {
    return axios.post(base.rentalArea.setLeaseBillAutoPaymentForCompanyLessee, utils.postParamsArrayToJsonString({ companyId, contractId }))
  },
  /**
  * 公司租户取消设置账单自动支付设置
  */
  unsetLeaseBillAutoPaymentForCompanyLessee (companyId, contractId) {
    return axios.post(base.rentalArea.unsetLeaseBillAutoPaymentForCompanyLessee, utils.postParamsArrayToJsonString({ companyId, contractId }))
  },
  /**
  * 公司租户查询所有自动支付合同
  */
  listLeaseContractOfBillAutoPaymentForCompanyLessee (companyId, contractsId) {
    contractsId = utils.arrayToJsonString(contractsId)
    return axios.post(base.rentalArea.listLeaseContractOfBillAutoPaymentForCompanyLessee, utils.postParamsArrayToJsonString({ companyId, contractsId }))
  },
  /**
  * 公司租户查询合同是否自动支付 
  */
  getLeaseContractBillAutoPaymentConfigForCompanyLessee (companyId, contractId) {
    return axios.post(base.rentalArea.getLeaseContractBillAutoPaymentConfigForCompanyLessee, utils.postParamsArrayToJsonString({ companyId, contractId }))
  },
  /**
  * 个人租户取消设置账单自动支付设置
  */
  unsetLeaseBillAutoPaymentForPersonalLessee (contractId) {
    return axios.post(base.rentalArea.unsetLeaseBillAutoPaymentForPersonalLessee, utils.postParamsArrayToJsonString({ contractId }))
  },
  getRentalAreaTrusteeshipIncomeBillForProperty (companyId, startTimeLeft, startTimeRight, proprietorCompaniesId, status) {
    return axios.post(base.rentalArea.getRentalAreaTrusteeshipIncomeBillForProperty, utils.postParamsArrayToJsonString({ companyId, startTimeLeft, startTimeRight, proprietorCompaniesId, status }))
  },
  getRentalAreaSwitches2 () {
    return axios.post(base.rentalArea.getRentalAreaSwitches2, utils.postParamsArrayToJsonString({ areasId }))
  }
}

export default rentalArea